import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          {/* Main Title */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 border-b-2 border-gray-200 pb-4">
            Shipping Policy
          </h1>

          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>
          
          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            
            <p>
              Regees Tex offers <span className="font-bold">free delivery across India</span> on all orders above <span className="font-bold">₹1,500</span>.
            </p>

            <p>
              Orders are processed and dispatched within <span className="font-bold">48 hours</span> of order confirmation.
            </p>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Shipping Partner:
              </h2>
              <p>ST Courier</p>
            </div>

            <p>
              Once the order is shipped, <span className="font-bold">tracking details (Airway Bill / Docket Number)</span> will be shared with customers via <span className="font-bold">SMS or Email</span>.
            </p>

            <p>
              All products are <span className="font-bold">securely double-packed</span> using waterproof and corrugated packaging to ensure safe delivery.
            </p>

            <p>
              Courier partners will attempt delivery <span className="font-bold">up to two times</span>. The estimated delivery timeline is <span className="font-bold">3–5 business days</span>, depending on the delivery location.
            </p>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Note:
              </h2>
              <p>
                Regees Tex is not responsible for delivery delays caused by customer unavailability, incorrect address details, natural calamities, or other external factors beyond our control.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;